module.exports = __webpack_public_path__ + "img/seven.547af3a6.png";